import { SET_SHOP_RATINGS, SET_SHOP_RATINGS_LOADING, SET_SHOP_RATINGS_ERROR } from './constants';

const initialState = {
  ratings: [],
  avgRating: null,
  ratingCount: 0,
  distribution: null,
  count: 0,
  pageSize: 10,
  page: 0,
  sort: 'recent',
  loading: false,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOP_RATINGS_LOADING:
      return { ...state, loading: action.loading, error: null };
    case SET_SHOP_RATINGS:
      return {
        ...state,
        ratings: action.payload.ratings || [],
        avgRating: action.payload.avgRating,
        ratingCount: action.payload.ratingCount,
        distribution: action.payload.distribution,
        count: action.payload.count,
        pageSize: action.payload.pageSize,
        page: action.payload.page,
        sort: action.payload.sort,
        loading: false,
        error: null,
      };
    case SET_SHOP_RATINGS_ERROR:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default reducer;
